export default __webpack_public_path__ + "static/bunfestival-3-9531444043b38a2137bb858cb3f2133a.png";